module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Biocode: Resolution")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-the-message"
    }
  }, [_vm._v("Chapter 1: The Message")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-hms-resolution"
    }
  }, [_vm._v("Chapter 2: HMS Resolution")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-the-taniwha1"
    }
  }, [_vm._v("Chapter 3: The Taniwha")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-back-to-new-zealand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Back to New Zealand")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-antarctica",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Antarctica")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-the-giants-graveyard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Giants’ Graveyard")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-return-to-geumdo-island",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Return to Geumdo Island")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-glagla-hawaii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Glagla Hawaii")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-secrets-of-rapa-nui",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Secrets of Rapa Nui")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-isla-de-pascua",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Isla de Pascua")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-the-funeral",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The Funeral")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-assassin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Assassin")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-quantum-entanglement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Quantum Entanglement")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-through-the-wormhole",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Through the Wormhole")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-save-james-fernley",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Save James Fernley")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-supervised-learning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Supervised Learning")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-sacrifice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Sacrifice")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0